<template>
  <div class="advantageMachine">
    <div>
      <img src="../assets/images/picture_09.png" alt="">
      <div class="ideaText">
        <div class="fz28">“线上与线下的客户赋能，企业与家庭融通的专业化体系”</div>
      </div>
    </div>
    <div class="colorTitle">
      <span>///</span> 线上个人IP打造 <span>///</span>
    </div>
    <div class="compText" style="margin-top: 20px;">保险“网红”孵化器，打造明星经纪人品牌，高效流量变现
    </div>
    <div class="redio">
      <video class="videoArea" id="video"
        src="https://img.zrbx.com/%E9%82%B5%E6%B9%84%E6%B8%85%EF%BC%88%E5%A3%B9%E5%BF%83%EF%BC%89%281%29%20%281%29.mp4"
        controls="true" preload="auto" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow"
        x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portraint"
        style="object-fit:fill">
      </video>
      <div class="playImage" @click="playVideo" v-if="showPlay">
        <img src="../assets/images/playCircle.png" alt="">
      </div>
    </div>
    <div class="colorTitle">
      <span>///</span> 互联网渠道协同线下高价值转化 <span>///</span>
    </div>
    <div>
      <img src="../assets/images/picture_36.png" alt="">
    </div>
    <div class="colorTitle">
      <span>///</span> 客户资源赋能的突破升级 <span>///</span>
    </div>
    <div>
      <img src="../assets/images/picture_37.png" alt="">
    </div>


  </div>
</template>

<script>
export default {
  name: 'advantageMachine',
  components: {},
  data() {
    return {
      showPlay: true
    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {
    playVideo() {
      const media = document.querySelector('#video')
      media.play()
      this.showPlay = false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.advantageMachine {
  width: 1024px;
  margin: 0 auto;

  &>div {
    margin-top: 40px;
    position: relative;

    .ideaText {
      width: 100%;
      color: #ffffff;
      position: absolute;
      top: 192px;
      text-align: center;

      &>div:first-child {
        font-weight: 600;
      }
    }

    img {
      width: 100%;
    }
  }

  .highLightTitle {
    text-align: center;
  }

  .redio {
    width: 100%;
    height: 512px;
    background-color: #000000;
    position: relative;

    .videoArea {
      width: 50%;
      margin-left: 25%;
    }

    .playImage {
      width: 180px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      img {
        width: 180px;
      }
    }
  }
}
</style>